import React from 'react';
import moment from 'moment-timezone';
import { getTableColumn, TableColumn, TextTooltip } from '@shared/UI';
import { IServiceTransferReportDto } from '@shared/api';
import { formats } from '@shared/utils';

export function getISOReportsTableColumns(): TableColumn<IServiceTransferReportDto>[] {
    return [
        getTableColumn({
            dataField: 'id',
            firstColumn: true,
            flex: 1,
            formatter: (data) => (
                <TextTooltip
                    maxLength={20}
                    text={String(data)}
                />
            ),
        }),
        getTableColumn({
            dataField: 'createdAt',
            firstColumn: true,
            flex: 1,
            formatter: (data) => moment(String(data)).format(formats.fullTime),
        }),
        getTableColumn({
            dataField: 'fileDate',
            title: 'Generated At',
            firstColumn: true,
            flex: 1,
            formatter: (data) => moment(String(data)).format(formats.fullTime),
        }),
    ];
}
